import React from 'react';

const screenshots = [
    { name: 'Dashboard', src: '/carousel/dashboard.png', alt: 'Dashboard Overview' },
    { name: 'Scan Dashboard', src: '/carousel/scan.png', alt: 'Domain Scanning Interface' },
    { name: 'Analysis Results', src: '/carousel/results.png', alt: 'Detailed Risk Analysis' },
    { name: 'Domain Report', src: '/carousel/report.png', alt: 'PDF Security Report' },
    { name: 'SOP Guide', src: '/carousel/SOP.png', alt: 'Takedown Standard Operating Procedure' },
    { name: 'Whitelist', src: '/carousel/whitelist.png', alt: 'Smart Whitelisting' },
];

export default function ProductStream() {
    const scrollRef = React.useRef(null);
    const [isDown, setIsDown] = React.useState(false);
    const [startX, setStartX] = React.useState(0);
    const [scrollLeft, setScrollLeft] = React.useState(0);
    const [selectedImage, setSelectedImage] = React.useState(null);

    // Drag to Scroll Logic
    const handleMouseDown = (e) => {
        setIsDown(true);
        setStartX(e.pageX - scrollRef.current.offsetLeft);
        setScrollLeft(scrollRef.current.scrollLeft);
    };
    const handleMouseLeave = () => setIsDown(false);
    const handleMouseUp = () => setIsDown(false);
    const handleMouseMove = (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - scrollRef.current.offsetLeft;
        const walk = (x - startX) * 2; // Scroll-fast
        scrollRef.current.scrollLeft = scrollLeft - walk;
    };

    return (
        <div className="py-24 bg-gray-900 dark:bg-dark-950 overflow-hidden relative">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto max-w-2xl text-center mb-16">
                    <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
                        See Inside TypoGuard
                    </h2>
                    <p className="mt-4 text-lg text-gray-300">
                        Powerful tools wrapped in a simple, intuitive interface.
                    </p>
                </div>
            </div>

            {/* Scrolling Carousel with Drag Support */}
            <div
                ref={scrollRef}
                className="relative flex overflow-x-auto overflow-y-hidden cursor-grab active:cursor-grabbing no-scrollbar scroll-smooth"
                onMouseDown={handleMouseDown}
                onMouseLeave={handleMouseLeave}
                onMouseUp={handleMouseUp}
                onMouseMove={handleMouseMove}
                style={{ scrollBehavior: isDown ? 'auto' : 'smooth' }}
            >
                <div className="flex gap-8 whitespace-nowrap py-8 px-8">
                    {/* Images */}
                    {screenshots.concat(screenshots).map((shot, index) => (
                        <div
                            key={`${shot.name}-${index}`}
                            className="relative aspect-[16/9] w-[400px] sm:w-[500px] flex-none overflow-hidden rounded-xl bg-gray-800 shadow-2xl ring-1 ring-white/10 transform transition-all duration-300 hover:scale-[1.02] hover:shadow-[0_0_20px_rgba(34,197,94,0.3)] hover:ring-green-500/50"
                            onClick={() => setSelectedImage(shot)}
                        >
                            <img
                                src={shot.src}
                                alt={shot.alt}
                                className="absolute inset-0 h-full w-full object-cover pointer-events-none"
                                loading="lazy"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-gray-900/60 to-transparent pointer-events-none" />
                            <div className="absolute bottom-4 left-4 pointer-events-none">
                                <p className="text-sm font-semibold text-white">{shot.name}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Image Modal */}
            {selectedImage && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4 transition-opacity duration-300"
                    onClick={() => setSelectedImage(null)}
                >
                    <div className="relative max-w-7xl w-full max-h-[90vh]">
                        <button
                            className="absolute -top-12 right-0 text-white hover:text-gray-300 text-3xl"
                            onClick={() => setSelectedImage(null)}
                        >
                            &times;
                        </button>
                        <img
                            src={selectedImage.src}
                            alt={selectedImage.alt}
                            className="w-full h-full object-contain rounded-lg shadow-2xl"
                        />
                        <p className="text-center text-white mt-4 text-xl font-semibold">{selectedImage.name}</p>
                    </div>
                </div>
            )}

            {/* Hide Scrollbar CSS */}
            <style>{`
        .no-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .no-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
        </div>
    );
}
